import type { JSX } from 'react';
import React from 'react';

import type { IDashboardUrlState, TDateRange } from '../ReportsConversionsDashboardPage.utils';
import ConversionsTrendTile from './ConversionsTrendTile';
import { useConversionsTrend, useKpiStats } from './KpiTiles.hooks';
import TotalConversionsTile from './TotalConversionsTile';
import TotalValueTile from './TotalValueTile';

import * as styles from './KpiTiles.css';

export interface IKpiTilesProps {
  range: TDateRange;
  state: IDashboardUrlState;
}

function KpiTiles({ range, state }: Readonly<IKpiTilesProps>): JSX.Element {
  const {
    currentStats,
    priorStats,
    isCurrentLoading,
    isPriorLoading,
    hasCurrentError,
    hasPriorError,
    priorRange,
  } = useKpiStats({ range });

  const {
    currentData,
    priorData,
    isLoading: isTrendLoading,
  } = useConversionsTrend({
    range,
    priorRange,
  });

  const isStatsLoading = isCurrentLoading || isPriorLoading;

  return (
    <div className={styles.tileRow}>
      <div className={styles.tile}>
        <TotalValueTile
          attr={state.attr}
          currentStats={currentStats}
          hasError={hasCurrentError || hasPriorError}
          isLoading={isStatsLoading}
          priorStats={priorStats}
        />
      </div>
      <div className={styles.tile}>
        <TotalConversionsTile
          attr={state.attr}
          currentStats={currentStats}
          hasError={hasCurrentError}
          isLoading={isCurrentLoading}
          priorStats={priorStats}
        />
      </div>
      <div className={styles.tile}>
        <ConversionsTrendTile
          currentData={currentData}
          hasError={false}
          isLoading={isTrendLoading}
          preset={state.timeframe}
          priorData={priorData}
          range={range}
        />
      </div>
    </div>
  );
}

export default KpiTiles;
